<div class="title mb-2">Upload Files</div>
<div
  class="box"
  (click)="photoSelect.click()"
  celoFileDrop
  [uploader]="uploader"
  (fileOver)="dropZoneState($event)"
  (filesDropped)="handleDrop($event)"
  [ngClass]="{
    valid: dropZoneActive === 'valid',
  }"
  #parent
>
  <div class="drop-highlight">
    <div>
      <i class="material-icons icon-xxl">cloud_upload</i>
      <div>UPLOAD</div>
    </div>
  </div>
  <div class="icon">
    <i class="material-icons">crop_original</i>
  </div>
  @if (singleFileOnly) {
    <div class="text">
      Drag a photo or a document to upload or <a class="celo-link">browse</a>
    </div>
  }
  @if (!singleFileOnly) {
    <div class="text">
      Drag photos or documents to upload or <a class="celo-link">browse</a>
    </div>
  }
  @if (!hideSubtitle) {
    <div class="subtitle">
      ( Up to 20 files in JPG, PNG, MP4, MOV and PDF. Videos up to 30 seconds )
    </div>
  }
</div>
<input
  [multiple]="!singleFileOnly"
  accept="image/png, image/jpeg, video/mp4, video/quicktime, application/pdf"
  #photoSelect
  class="d-none"
  type="file"
  aria-label="Choose files to upload"
  id="celo-textbar"
  celoFileSelect
  [uploader]="uploader"
  (change)="closeNow()"
/>

<mat-dialog-actions class="buttons" align="end">
  <button class="celo-secondary-button cancel-button" mat-dialog-close>
    Cancel
  </button>
</mat-dialog-actions>
